import { getRuntimeConfig } from '@front/runtime-config'

const {
  public: { monorepoServiceAdminUrl: monorepoAdminUrl },
} = getRuntimeConfig()

export const adminMeUrl = `${monorepoAdminUrl}/me`
export const adminSessionUrl = `${monorepoAdminUrl}/session`
export const adminLoginUrl = `${monorepoAdminUrl}/login`
export const adminShiftUrl = `${monorepoAdminUrl}/shift`
export const adminWorkerUrl = `${monorepoAdminUrl}/worker`
export const adminSlotsUrl = `${monorepoAdminUrl}/slots`
export const agencyShiftRequestInfoUrl = `${monorepoAdminUrl}/agencies/shift-request/:idRequest/info`
export const adminPermissionsUrl = `${monorepoAdminUrl}/permissions`
export const adminWorkerAvailabilities = `${monorepoAdminUrl}/network/:idNetwork/profile/:hubloId/availabilities`
